import { AppFooter } from '@mindly/ui-components';
import styled from 'styled-components';

export const SubscriptionsPlansWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 5px;

  & .plans-step {
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: #5b5b5b;
    margin-bottom: 10px;
  }

  & .plans-title {
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    color: #1d201f;
    margin-bottom: 20px;
  }

  & .plans-list.loading {
    li::before {
      display: none;
    }

    li {
      margin-bottom: 14px;
    }

    li:last-child {
      margin-bottom: 0;
    }
  }

  & .plans-sub {
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: #5b5b5b;
    margin-bottom: 20px;
  }

  & .plans-segment {
    column-gap: 5px;
    --background: #ffffff;
    margin-bottom: 4px;
    padding-bottom: 10px;
    border-radius: 0;
  }

  & .plans-segment-button {
    position: relative;
    --background: #c1c1c1;
    --background-checked: #177590;
    --border-radius: 5px;
    margin: 0;
    --padding-bottom: 19px;
    --padding-top: 19px;
    --indicator-color: #177590;
    --indicator-box-shadow: none;
    --indicator-transform: none;
    --indicator-transition: none;

    &.segment-button-checked {
      &::after {
        content: '';
        position: absolute;
        display: block;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 10px 9px 0 9px;
        border-color: #177690 transparent transparent transparent;
        bottom: -10px;
        left: 50%;
        transform: translateX(-50%);
      }
    }

    &::before {
      display: none;
    }
  }

  & .plans-segment-button.loading {
    --background: transparent;

    &::part(native) {
      padding: 0;
    }
  }

  & .plans-label {
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    color: #ffffff;
  }

  & .plans-footer-help {
    outline: none;
    border: none;
    display: flex;
    align-items: center;
    column-gap: 4px;
    background: transparent;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    color: #1d201f;
    margin-bottom: 20px;

    & ion-icon {
      font-size: 30px;
    }
  }
`;

export const SubscriptionsPlansFooter = styled(AppFooter)`
  border: none;
  padding-bottom: 16px;
`;

export const SubscriptionsTable = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  margin-bottom: 45px;
`;
